import { render, staticRenderFns } from "./NotAuthorizedView.vue?vue&type=template&id=4ab13f40"
import script from "./NotAuthorizedView.vue?vue&type=script&lang=js"
export * from "./NotAuthorizedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports